import { useInView } from '@/hooks/useInView';
import { useEffect } from 'react';
import { useEventListener, useMediaQuery } from 'usehooks-ts';

export function usePrefetchQuery<E extends HTMLElement>(
  prefetchQuery: () => void
) {
  const { ref, hasIntersected } = useInView<E>();
  const matches = useMediaQuery('(pointer: coarse)');

  useEventListener('mouseenter', prefetchQuery, ref, {
    once: true,
  });

  useEffect(() => {
    if (hasIntersected && matches) {
      prefetchQuery();
    }
  }, [hasIntersected, matches, prefetchQuery]);

  return ref;
}
